<template>
  <div id="app">
    <section :style="`opacity:${showApp?1:0}`">
      <page-home v-show="homeShow" />
      <landscape
        v-show="landscapeShow"
        @landscape-show="landscapeShow=true"
        @landscape-hide="landscapeShow=false"
      />
      <loading v-show="loadingShow" @finish="$bus.emit('loading-hide')" />
    </section>
  </div>
</template>

<script>
import Home from './views/pages/Home';
import Landscape from './views/pages/Landscape';
import Loading from './views/pages/Loading';

export default {
  name: 'app',
  components: {
    'page-home': Home,
    landscape: Landscape,
    loading: Loading
  },
  data() {
    let result = {};
    // 多页面
    let pages = ['home', 'landscape', 'loading'];
    for (let page of pages) {
      result[`${page}Show`] = false;
    }
    result.pages = pages;
    result.showApp = false;
    return result;
  },
  created() {
    this.initPages();
    this.$bus.on('ping-finish',showApp=>{
      this.showApp = showApp;
    });
  },
  mounted() {
    this.$bus.emit('loading-show');
  },
  methods: {
    // 多页面控制初始化
    initPages() {
      let pages = this.pages;
      for (let page of pages) {
        this.$bus.on(`${page}-show`, () => {
          this[`${page}Show`] = true;
        });
        this.$bus.on(`${page}-hide`, () => {
          this[`${page}Show`] = false;
        });
      }
    }
  }
};
</script>

<style scoped>
#app {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  overflow: hidden;
}
</style>
